<div class="panel" #actionsPanel>
  <div class="hidden print-flex  justify-center -mt-2 mb-3">@if (!isBluebird) {
    <img class="h-14"
      src="/assets/logo.png" />
    }@if (isBluebird) {
    <img class="h-12" src="/assets/bluebirdlogo.png" />
  }</div>
  <div class=" p-4 mb-4 lg:mx-4 print-no-margin">
    <div>
      <h2>{{auditResultDetail.AuditName}}</h2>
      <h3>{{auditResultDetail.Location.LocationName}}</h3>
      <div class="mt-4">
        <p class="text-sm">Completed by: <span>{{auditResultDetail.UserCreatedName}}</span></p>
        <p class="text-sm">Date: <span>{{humanDate(auditResultDetail.SubmittedDate)}}</span></p>
      </div>
    </div>


    <table class="mt-2 !w-full table-auto bg-standardwhite border border-grey-900 action-table rounded-sm">
      <thead>
        <tr class="border-b-[1px] border-green-700 ">
          <th class="text-left print-text-xs pr-1 border-r-[1px] border-grey-300 ">Question</th>
          <th class="text-left print-text-xs  pr-1 border-r-[1px] border-grey-300">Answer</th>
          @if (hasComments) {
            <th class="text-left pr-1 border-r-[1px] print-text-xs  border-grey-300">
            Comments</th>
          }
          @if (hasReference) {
            <th class="text-left pr-1 border-r-[1px] print-text-xs  border-grey-300 ">
            Reference</th>
          }
          <th class="text-left pr-1 border-r-[1px] border-grey-300 print-text-xs ">Action</th>
          <th class="text-left pr-1 border-r-[1px] border-grey-300 print-text-xs ">Action Owner</th>
          <th class="text-left pr-1 border-r-[1px] border-grey-300 print-text-xs ">Action Due</th>
          <th class="text-left pr-1 border-r-[1px] border-grey-300 print-text-xs ">Action Taken</th>
          <th class="text-left pr-1 print-text-xs ">Resolved</th>
        </tr>
      </thead>
      <tbody>
        @for (q of actionQuestionList; track q) {
          @for (a of q.Actions; track a) {
            <tr class="border-b-[1px] border-grey-300">
              <td class="border-r-[1px] border-grey-300 max-w-[50%] print-text-xs">
                {{ q.QuestionHeader }}
                @if (q.QuestionBody.length > 0) {
                  <p class="print-text-xs text-xs text-grey-900">{{ q.QuestionBody }}</p>
                }
              </td>
              <td class="border-r-[1px] border-grey-300 text-center print-text-xs">{{ q.QuestionResult }}</td>
              @if (hasComments) {
                <td class="border-r-[1px] border-grey-300 max-w-72 print-text-xs">{{
                q.QuestionComments }}</td>
              }
              @if (hasReference) {
                <td class="border-r-[1px] border-grey-300 max-w-72 print-text-xs">
                  {{ q.ReferenceQuestion }}
                  <p class="font-semibold mt-1 print-text-xs text-center">{{
                  q.ReferenceAnswer }}</p>
                </td>
              }
              <td class="border-r-[1px] border-grey-300 print-text-xs">{{ a.ActionDescription }}</td>
              <td class="border-r-[1px] border-grey-300 print-text-xs text-center">{{ a.AssignedTo }}</td>
              <td class="border-r-[1px] border-grey-300 min-w-24 print-text-xs text-center">{{ humanDate(a.ActionDeadline)
              }}</td>
              <td class="border-r-[1px] border-grey-300 print-text-xs"></td>
              <td>
                @if (a.Resolved) {
                  <p class="print-text-xs text-xs">{{humanDate(a.ResolvedDate)}}</p>
                }
                @if (a.Resolved) {
                  <p class="print-text-xs text-xs">By @if (a.Resolved) {
                    <span class="print-text-xs text-xs font-bold">{{a.ResolvedBy}}</span>
                  }</p>
                }
              </td>
            </tr>
          }
        }
      </tbody>

    </table>
  </div>
</div>
